/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgWorkersUnbound = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.304 1.916H6.065l4.464 6.1-4.357 5.9h1.243l4.356-5.897-4.467-6.103z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.24 12.294L3.025 7.992l3.196-4.178-.615-.841-3.605 4.711L2 8.287l3.62 4.847.62-.84zM8.444 1.916h1.251l4.306 5.727-.002.603-4.301 5.67H8.442l4.533-5.974-4.531-6.026z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.763 5.264L4.79 7.284l.573.558.899-.92v2.323h1V6.921l.899.921.572-.559-1.971-2.019zM6.263 10.007v1h1v-1h-1z"
}));

export default SvgWorkersUnbound;